import React from 'react';
import styles from './components.module.css';

export interface SuccessStateProps {
  title?: string;
  message?: string;
}

export const SuccessState: React.FC<SuccessStateProps> = ({
  title = 'Enviado com sucesso!',
  message = 'Sua resposta foi registrada.',
}) => {
  return (
    <div className={styles.successContainer}>
      <div className={styles.successIcon}>✓</div>
      <h3 className={styles.successTitle}>{title}</h3>
      <p className={styles.successMessage}>{message}</p>
    </div>
  );
};

export default SuccessState;
